/**
 * MEU ERP API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SaSheetOtData { 
    id?: string;
    sheet_id?: string;
    ot_id?: string;
    sheet_staff_id?: string;
    start?: Date;
    finish?: Date;
    ot_category_id?: string;
    total_hour?: number;
    ot_rate?: number;
    created_at?: Date;
    created_by?: string;
    modified_at?: Date;
    modified_by?: string;
    ot_category_name?: string;
}